import script from "./DesignerApplyDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesignerApplyDialog.vue?vue&type=script&lang=ts&setup=true"

import "./DesignerApplyDialog.vue?vue&type=style&index=0&id=541473a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-541473a8"]])

export default __exports__